const blur = {}
export default blur;
